function SvgComponent(props: any) {

    return (
        <svg
            width={84}
            height={84}
            viewBox="0 0 84 84"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
        <circle cx={42} cy={42} r={42} fill={props.isHover ? "#EDFFF5" : "#F6F3FF"} />
        <path
            d="M43 58.667H31.333c-.92 0-1.666-.747-1.666-1.667V27c0-.92.746-1.667 1.666-1.667h23.334c.92 0 1.666.746 1.666 1.667v15M52.583 58.667V47.833"
            stroke={props.isHover ? "#27AE60" : "#5627FF"}
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M48.833 50.75l1.25-1.25 2.5-2.5 2.5 2.5 1.25 1.25"
            stroke={props.isHover ? "#27AE60" : "#5627FF"}
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M36.333 35.333h13.333M36.333 42H43"
            stroke={props.isHover ? "#27AE60" : "#5627FF"}
            strokeWidth={2}
            strokeLinecap="round"
        />
        </svg>
    )
}
  
  export default SvgComponent